import { getFilterCompanyId } from 'appRedux/selectors/utility';

export const getFormattedRequestUsersQueryParams = (filters) => ({
  page: filters.page,
  per_page: filters.perPage,
  query: filters.query,
  company_is_active: filters.companyIsActive === 'view_all' ? undefined : filters.companyIsActive,
  company_id: getFilterCompanyId(filters),
});
